"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledUpload = exports.StyledInput = exports.StyledPreview = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPreview = styled_components_1.default.img(function (_a) {
    var space = _a.theme.space;
    return "\n  display: block;\n  max-width: 100%;\n  margin-bottom: ".concat(space[4], "\n");
});
exports.StyledInput = styled_components_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
exports.StyledUpload = styled_components_1.default.div(function (_a) {
    var _b = _a.theme, colors = _b.colors, space = _b.space;
    return "\n  background: ".concat(colors.primaryMuted, ";\n  padding: ").concat(space[6], ";\n");
});
exports.StyledButton = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  // override button svg style\n  svg:first-child {\n    margin-right: 0.6rem;\n    height: 1.8rem;\n    align-self: center;\n  }\n"], ["\n  display: flex;\n\n  // override button svg style\n  svg:first-child {\n    margin-right: 0.6rem;\n    height: 1.8rem;\n    align-self: center;\n  }\n"])));
var templateObject_1, templateObject_2;
